import { render, staticRenderFns } from "./RecaptchaDialog.vue?vue&type=template&id=4310c033&scoped=true"
import script from "./RecaptchaDialog.vue?vue&type=script&lang=js"
export * from "./RecaptchaDialog.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaDialog.vue?vue&type=style&index=0&id=4310c033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310c033",
  null
  
)

export default component.exports